// @flow
import { APIError } from '../generalCreators';
import {
  getOrganisation,
  updateCurrentOrganisation
} from '../organisations/organisationCreators';
import { updateCurrentLocation } from '../locations/locationCreators';
import type { ThunkAction } from '../../types';

export function updateActiveOrganisation(
  organisationId: number,
  withSettings: boolean = true
  // $FlowFixMe
): ThunkAction {
  return function(dispatch, getState) {
    return dispatch(getOrganisation(organisationId, withSettings)).then(
      orgWithSettings => {
        dispatch({
          type: 'UPDATE_ACTIVE_ORGANISATION',
          organisation: orgWithSettings
        });
      },
      error => dispatch(APIError(error, 'Error updating Active Organisation'))
    );
  };
}

export function setCurrentOrganisationOrLocation(
  organisationId: number,
  context: string = 'global',
  withSettings: boolean = true
  // $FlowFixMe
): ThunkAction {
  return function(dispatch, getState) {
    switch (context) {
      default:
      case 'global':
      case 'customer':
        return dispatch(
          updateCurrentOrganisation(organisationId, withSettings)
        );
      case 'sub-account':
        return dispatch(updateCurrentLocation(organisationId, withSettings));
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/organisations/activeOrganisationCreators.js